import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Anchor from 'Components/common/Anchor';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import BasicButton from 'Components/common/BasicButton';
import BasicInput from 'Components/common/BasicInput';
import Dialog from 'Components/common/Dialog';
import DeliverCard from 'Components/host/DeliverCard';
import EditOtherPhotosDialog from 'Components/host/EditOtherPhotosDialog';
import {loadLanguage} from 'Utils/jwtUtil';
import LoadingIcon from 'Components/icons/LoadingIcon';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getDeliverDetails,
    updateTrackingNumber,
    updateShipment,
    uploadReceiveImage,
    createInvoicePdf,
    enterSalesDeliverDetail,
    b2bCasmartShipment,
} from 'Actions/host';
import {T} from 'Actions/translate';
import {base64ShippingImage} from 'Utils/constant';

// Icons
import {ArrowBackIos} from '@material-ui/icons';

class DeliverDetails extends React.Component {
    state = {
        previewReceiveImageDialogOpened: false,
        previewPlacementImageDialogOpened: false,
        previewOtherImagesDialogOpened: false,
        uploadReceiveImageDialogOpened: false,
        cancelOrderDialogOpened: false,
        cancelWithdrawalPackage: false,
        waitSendGoodsDialogOpened: false,
        chooseShipmentItem: null,
        chooseImage: {file: null, url: ''},
        uploadFileBtnIsLoading: false,
        skuInventoryExitOpened: false,
        skuInventoryDetailData: [],
        sQuoteFailureDialogOpened: false,
        currentShipFlag: 0,
        currentShipmentId: '',
        currentOrderId: '',
        currentFinancialStatus: '',
        addTrackNumberDialogOpened: false,
        trackNumber: '',
        currentShipments: [],
        deliverDetailsPageLoad: true,
        shipmentDetails: {},
        shipmentCards: [],
        placementPreviewImg: '',
        currentOtherImageIndex: 0,
        uploadOtherPhotosDialogOpened: false,
        noOtherPhotosDialogOpened: false,
        otherPhotosShipmentItem: null,
    };

    componentWillMount() {
        this.getInitData();
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (
            JSON.stringify(routerState) !== '{}' &&
            typeof routerState.fromSalesOrderDetail !== 'undefined' &&
            routerState.fromSalesOrderDetail
        ) {
            this.props.enterSalesDeliverDetail({$set: true});
        }
    }

    getInitData = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });

        this.props
            .getDeliverDetails({orderId: parseInt(this.params.orderId)})
            .then((res) => {
                setTimeout(() => {
                    this.setState({
                        currentShipFlag: parseInt(this.params.shipFlag),
                        shipmentDetails: res.data,
                        deliverDetailsPageLoad: false,
                    });
                });
                if (
                    res &&
                    res.data &&
                    res.data.shipmentCards &&
                    res.data.shipmentCards.length > 0
                ) {
                    let shipmentCards = JSON.parse(
                        JSON.stringify(res.data.shipmentCards),
                    );
                    shipmentCards.map((item) => {
                        item.changeBtn = true;
                    });
                    this.setState({
                        shipmentCards,
                    });
                }
            })
            .catch((res) => {
                this.setState({
                    deliverDetailsPageLoad: true,
                });
            });
    };

    goBack = () => {
        this.props.history.goBack();
    };

    ship = () => this.props.history.push(`/shipEdit/${this.params.orderId}`);
    openCancelOrderDialog = () =>
        this.setState({cancelOrderDialogOpened: true});

    dialogDidClose = (key) =>
        this.state[key] &&
        this.setState({
            chooseShipmentItem: null,
            [key]: false,
            ...(key === 'previewPlacementImageDialogOpened'
                ? {placementPreviewImg: ''}
                : {}),
        });

    closeDialog = (name) => {
        if (this.state.skuInventoryExitOpened) {
            this.setState({
                skuInventoryExitOpened: false,
                skuInventoryDetailData: [],
            });
        }
    };

    getShipmentTagStatus = (shipmentStatus) => {
        let lang = loadLanguage();
        let tagObje = {};
        if (shipmentStatus === -1) {
            tagObje = {
                tag: true,
                'package-canceled': lang !== 'EN',
                'en-package-canceled': lang === 'EN',
            };
        } else if (shipmentStatus === 1) {
            tagObje = {
                tag: true,
                'wait-shipped': lang !== 'EN',
                'en-wait-shipped': lang === 'EN',
            };
        } else if (shipmentStatus === 3) {
            tagObje = {
                tag: true,
                'wait-received': lang !== 'EN',
                'en-wait-received': lang === 'EN',
            };
        } else if (shipmentStatus === 4) {
            tagObje = {
                tag: true,
                'completed-received': lang !== 'EN',
                'en-completed-received': lang === 'EN',
            };
        }
        return tagObje;
    };

    handleEditOtherPhotosDialog = (item) => {
        this.setState({
            uploadOtherPhotosDialogOpened: true,
            otherPhotosShipmentItem: item,
        });
    };

    handleUploadReceiveImageDialog = (item) => {
        this.setState(
            {
                chooseShipmentItem: item,
                uploadReceiveImageDialogOpened: true,
                chooseImage: {file: null, url: ''},
            },
            () => {
                this.refs['inputFile'].value = '';
            },
        );
    };

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();
    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }

        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };
    uploadReceiveImage = () => {
        const {chooseImage, chooseShipmentItem} = this.state;

        if (!chooseShipmentItem)
            return this.props.openNotification(
                T('notification_please_select_package'),
                'danger',
            );

        this.setState({uploadFileBtnIsLoading: true});

        this.props
            .uploadReceiveImage({type: 'receipt', file: chooseImage.file})
            .then((res) => this.updateShipment(res))
            .finally(() => {
                this.setState({uploadFileBtnIsLoading: false});
            });
    };

    updateShipment = (res) => {
        const {chooseShipmentItem} = this.state;

        this.props
            .updateShipment({
                shipmentId: chooseShipmentItem.shipmentId,
                receiveImg: res.url,
            })
            .then((status) => {
                this.props.openNotification(
                    T('notification_successfully_upload'),
                    'success',
                    {time: 2000},
                );
                this.setState({
                    uploadReceiveImageDialogOpened: false,
                    chooseItem: null,
                });
                this.getInitData();
            });
    };

    previewReceiveImage = (item) => {
        this.setState({
            chooseShipmentItem: item,
            previewReceiveImageDialogOpened: true,
        });
    };

    previewPlacementImage = (item) => {
        if (!item || !item.locationImg) return;
        this.setState({
            previewPlacementImageDialogOpened: true,
            placementPreviewImg: item.locationImg,
        });
    };

    getPreviewImageUrl = (imageUrl) =>
        /^https?:\/\//.test(imageUrl)
            ? imageUrl
            : util.getImageRoot() + imageUrl;

    previewOtherImages = (item, currentOtherImageIndex = 0) => {
        this.setState({
            chooseShipmentItem: item,
            currentOtherImageIndex,
            previewOtherImagesDialogOpened: true,
        });
    };

    setPreviewOtherImageIndex = (currentOtherImageIndex) => {
        this.setState({currentOtherImageIndex});
    };

    previewInvoice = (item) => {
        this.props.createInvoicePdf({id: item.shipmentId}).then((res) => {
            if (util.isIOS()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-preview.html?url=' +
                    window.encodeURIComponent(
                        `${util.getImageRoot() + res.data}`,
                    );
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-preview.html?url=' +
                        window.encodeURIComponent(
                            `${util.getImageRoot() + res.data}`,
                        ),
                    '_blank',
                );
            }
        });
    };

    openTrackNumberDialog = (item) => {
        this.setState({
            addTrackNumberDialogOpened: true,
            currentShipments: item,
            trackNumber: item.expressNumber,
        });
    };

    handleChange = (name, value) => {
        this.setState({
            trackNumber: value,
        });
    };
    addTrackNumberHandle = () => {
        let {trackNumber, currentShipments} = this.state;
        let shipmentId = currentShipments.shipmentId;

        if (trackNumber.trim()) {
            this.props
                .updateTrackingNumber({
                    shipmentId: shipmentId,
                    expressNumber: trackNumber.trim(),
                })
                .then(() => {
                    this.props.openNotification(
                        T('shippment_update_tracking_number_success'),
                        'success',
                        {time: 2000},
                    );
                    this.setState({
                        trackNumber: '',
                        addTrackNumberDialogOpened: false,
                        currentShipments: [],
                    });
                    this.getInitData();
                });
        }
    };

    switchBtn = (index, type) => {
        const {shipmentCards} = this.state;
        let data = shipmentCards;
        if (data && data.length > 0) {
            data.map((item, dataIndex) => {
                if (dataIndex === index && type === 'more') {
                    item.changeBtn = true;
                }
                if (dataIndex === index && type == 'less') {
                    item.changeBtn = false;
                }
            });
            this.setState({
                shipmentCards: data,
            });
        }
    };

    b2bCasmartShipmentHandle = (params) => {
        this.props
            .b2bCasmartShipment(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    console.log(res);
                    if (util.isWechatBrowser()) {
                        if (util.isIOS()) {
                            window.location.href =
                                window.location.origin +
                                '/pdf-preview/pdf-preview.html?url=' +
                                window.encodeURIComponent(
                                    `${util.getImageRoot() + res.data}`,
                                );
                        } else {
                            window.open(
                                window.location.origin +
                                    '/pdf-preview/pdf-preview.html?url=' +
                                    window.encodeURIComponent(
                                        `${util.getImageRoot() + res.data}`,
                                    ),
                                '_blank',
                            );
                        }
                    } else {
                        window.open(res.data, '_blank');
                    }
                } else {
                    this.props.openNotification(T(res.message), 'danger');
                }
            })
            .catch((err) => {
                if (err && err.status === 'po_number_empty') {
                    this.props.openNotification(T('po_number_empty'), 'danger');
                } else if (
                    err &&
                    err.status === 'b2b_shipment_integration_error'
                ) {
                    this.props.openNotification(
                        T('order_contact_service'),
                        'danger',
                    );
                } else {
                    this.props.openNotification(T(err.message), 'danger');
                }
            });
    };

    render() {
        const {
            shipmentDetails,
            uploadFileBtnIsLoading,
            chooseShipmentItem,
            chooseImage,
            uploadReceiveImageDialogOpened,
            previewPlacementImageDialogOpened,
            previewReceiveImageDialogOpened,
            previewOtherImagesDialogOpened,
            addTrackNumberDialogOpened,
            trackNumber,
            currentShipments,
            deliverDetailsPageLoad,
            shipmentCards,
            placementPreviewImg,
            currentOtherImageIndex,
            uploadOtherPhotosDialogOpened,
            noOtherPhotosDialogOpened,
            otherPhotosShipmentItem,
        } = this.state;
        const {localData} = this.props;
        const isHaveShipmentImage =
            chooseShipmentItem && chooseShipmentItem.receivedImg;
        let lang = loadLanguage();
        return (
            <div
                className="deliver-details-container"
                testid="delivery-details-root">
                <div className="header-wrap">
                    <div className="shipment-details-header container-max-width is-fixed">
                        <Anchor
                            className="go-back"
                            testid="delivery-details-back-button"
                            onClickOfSingleTap={this.goBack}>
                            <ArrowBackIos />
                        </Anchor>
                        {T('shippment_delivery_details')}
                    </div>
                </div>
                {deliverDetailsPageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <div testid="delivery-details-shipment-row">
                        <div className="content-box">
                            <p className="order-number">
                                <label>{T('shippment_order_number')}</label>{' '}
                                <span
                                    testid={`delivery-details-order-number-${shipmentDetails.orderNumber}`}>
                                    {shipmentDetails.orderNumber}
                                </span>
                            </p>
                            <p className="eone-order-number">
                                <label>{T('shippment_eone_number')}</label>{' '}
                                <span testid="delivery-details-e1-number">
                                    {shipmentDetails.e1Number}
                                </span>
                            </p>
                            <p className="cancel-time">
                                <label>{T('shippment_purchase_date')}</label>
                                <span>{shipmentDetails.createDate}</span>
                            </p>
                        </div>
                        {shipmentCards && shipmentCards.length > 0 ? (
                            <ul className="shipment-card-ul">
                                {shipmentCards.map(
                                    (shipmentCardItem, shipmentCardIndex) => (
                                        <li
                                            className="shipment-card-li"
                                            testid={`delivery-details-package-${shipmentCardItem.shipmentId}`}
                                            key={shipmentCardIndex}>
                                            {shipmentCardItem.shipmentStatus ===
                                                3 ||
                                            shipmentCardItem.shipmentStatus ===
                                                4 ? (
                                                <div>
                                                    <div className="first-shipment-card">
                                                        <div className="first-row delivery-id">
                                                            <div className="card-label">
                                                                {T(
                                                                    'shippment_delivery_id',
                                                                )}
                                                            </div>
                                                            <span testid="shipment-delivery-id">
                                                                {
                                                                    shipmentCardItem.shipmentId
                                                                }
                                                            </span>
                                                        </div>
                                                        {shipmentCardItem.expressNumber ? (
                                                            <div className="second-row">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shippment_shipped_express_number',
                                                                    )}
                                                                </div>
                                                                <span>
                                                                    {
                                                                        shipmentCardItem.expressNumber
                                                                    }
                                                                </span>
                                                            </div>
                                                        ) : null}
                                                        <div className="third-row">
                                                            <div className="card-label">
                                                                {T(
                                                                    'shippment_details_actual_ship_date',
                                                                )}
                                                            </div>
                                                            <span testid="shipment-delivery-date">
                                                                {
                                                                    shipmentCardItem.shipmentDate
                                                                }
                                                            </span>
                                                        </div>
                                                        {shipmentCardItem.shipmentStatus ===
                                                        4 ? (
                                                            <div className="received-row">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shipment_received_date',
                                                                    )}
                                                                </div>
                                                                <span testid="shipment-received-date">
                                                                    {
                                                                        shipmentCardItem.receivedDate
                                                                    }
                                                                </span>
                                                            </div>
                                                        ) : null}
                                                        {(localData.roleType ===
                                                            1 ||
                                                            localData.roleType ===
                                                                2) &&
                                                        shipmentCardItem.shipmentStatus ===
                                                            3 &&
                                                        !shipmentCardItem.receivedImg ? (
                                                            <div
                                                                className="fourth-row"
                                                                testid="shipment-invoice-section">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shippment_delivery_order',
                                                                    )}
                                                                </div>
                                                                <span className="preview-shipment">
                                                                    <Anchor
                                                                        className="btn"
                                                                        testid="shipment-invoice-preview"
                                                                        onClickOfSingleTap={() =>
                                                                            this.previewInvoice(
                                                                                shipmentCardItem,
                                                                            )
                                                                        }>
                                                                        {T(
                                                                            'shippment_preview',
                                                                        )}
                                                                    </Anchor>
                                                                    {localData.roleType ===
                                                                    2 ? (
                                                                        <Anchor
                                                                            className="btn"
                                                                            onClickOfSingleTap={() =>
                                                                                this.openTrackNumberDialog(
                                                                                    shipmentCardItem,
                                                                                )
                                                                            }>
                                                                            {T(
                                                                                'shippment_add_tracking_number',
                                                                            )}
                                                                        </Anchor>
                                                                    ) : null}
                                                                </span>
                                                            </div>
                                                        ) : shipmentCardItem.shipmentStatus ===
                                                              4 ||
                                                          shipmentCardItem.receivedImg ? (
                                                            <div className="fourth-row">
                                                                <div className="first-column">
                                                                    {shipmentCardItem.shipmentStatus ===
                                                                        4 ||
                                                                    shipmentCardItem.receivedImg ? (
                                                                        <div className="card-label">
                                                                            {T(
                                                                                'shippment_sign_receipt',
                                                                            )}
                                                                        </div>
                                                                    ) : null}
                                                                    <span className="preview-shipment">
                                                                        {shipmentCardItem.shipmentStatus ===
                                                                            4 ||
                                                                        shipmentCardItem.receivedImg ? (
                                                                            <Anchor
                                                                                className="btn"
                                                                                testid="shipment-receipt-proof-preview"
                                                                                onClickOfSingleTap={() =>
                                                                                    this.previewReceiveImage(
                                                                                        shipmentCardItem,
                                                                                    )
                                                                                }>
                                                                                {T(
                                                                                    'shippment_preview',
                                                                                )}
                                                                            </Anchor>
                                                                        ) : null}
                                                                        {localData.roleType ===
                                                                            2 &&
                                                                        shipmentCardItem.shipmentStatus ===
                                                                            4 ? (
                                                                            <Anchor
                                                                                className="btn"
                                                                                onClickOfSingleTap={() =>
                                                                                    this.handleUploadReceiveImageDialog(
                                                                                        shipmentCardItem,
                                                                                    )
                                                                                }>
                                                                                {T(
                                                                                    'shippment_upload_again',
                                                                                )}
                                                                            </Anchor>
                                                                        ) : null}
                                                                    </span>
                                                                </div>
                                                                {localData.roleType ===
                                                                    1 ||
                                                                localData.roleType ===
                                                                    2 ? (
                                                                    <div
                                                                        className="second-column"
                                                                        testid="shipment-invoice-section">
                                                                        <div className="card-label">
                                                                            {T(
                                                                                'shippment_delivery_order',
                                                                            )}
                                                                        </div>
                                                                        <span className="preview-shipment">
                                                                            <Anchor
                                                                                className="btn"
                                                                                testid="shipment-invoice-preview"
                                                                                onClickOfSingleTap={() =>
                                                                                    this.previewInvoice(
                                                                                        shipmentCardItem,
                                                                                    )
                                                                                }>
                                                                                {T(
                                                                                    'shippment_preview',
                                                                                )}
                                                                            </Anchor>
                                                                            {localData.roleType ===
                                                                            2 ? (
                                                                                <Anchor
                                                                                    className="btn"
                                                                                    onClickOfSingleTap={() =>
                                                                                        this.openTrackNumberDialog(
                                                                                            shipmentCardItem,
                                                                                        )
                                                                                    }>
                                                                                    {T(
                                                                                        'shippment_add_tracking_number',
                                                                                    )}
                                                                                </Anchor>
                                                                            ) : null}
                                                                        </span>
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        ) : null}

                                                        {shipmentCardItem.otherImages &&
                                                        shipmentCardItem
                                                            .otherImages
                                                            .length > 0 ? (
                                                            <div className="shipment-other-images">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shippment_other_photos',
                                                                    )}
                                                                </div>
                                                                <Anchor
                                                                    className="btn"
                                                                    testid="shipment-other-photos-preview"
                                                                    onClickOfSingleTap={() =>
                                                                        this.previewOtherImages(
                                                                            shipmentCardItem,
                                                                        )
                                                                    }>
                                                                    {T(
                                                                        'shippment_preview',
                                                                    )}
                                                                </Anchor>
                                                                {localData.roleType ===
                                                                2 ? (
                                                                    <Anchor
                                                                        className="btn edit-other-images-btn"
                                                                        onClickOfSingleTap={() =>
                                                                            this.handleEditOtherPhotosDialog(
                                                                                shipmentCardItem,
                                                                            )
                                                                        }>
                                                                        {T(
                                                                            'shippment_edit_upload',
                                                                        )}
                                                                    </Anchor>
                                                                ) : null}
                                                            </div>
                                                        ) : (
                                                            <div className="shipment-other-images">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shippment_other_photos',
                                                                    )}
                                                                </div>
                                                                <Anchor
                                                                    className="btn"
                                                                    testid="shipment-other-photos-preview"
                                                                    onClickOfSingleTap={() =>
                                                                        this.setState(
                                                                            {
                                                                                noOtherPhotosDialogOpened: true,
                                                                            },
                                                                        )
                                                                    }>
                                                                    {T(
                                                                        'shippment_preview',
                                                                    )}
                                                                </Anchor>
                                                                {localData.roleType ===
                                                                2 ? (
                                                                    <Anchor
                                                                        className="btn edit-other-images-btn"
                                                                        onClickOfSingleTap={() =>
                                                                            this.handleEditOtherPhotosDialog(
                                                                                shipmentCardItem,
                                                                            )
                                                                        }>
                                                                        {T(
                                                                            'shippment_edit_upload',
                                                                        )}
                                                                    </Anchor>
                                                                ) : null}
                                                            </div>
                                                        )}

                                                        {
                                                            <div className="fourth-row">
                                                                {shipmentCardItem.receivingCode && (
                                                                    <div className="first-column">
                                                                        <div className="card-label">
                                                                            {T(
                                                                                'shippment_upload_receive_code',
                                                                            )}
                                                                        </div>
                                                                        <span>
                                                                            {
                                                                                shipmentCardItem.receivingCode
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {shipmentCardItem.locationImg ? (
                                                                    <div className="second-column">
                                                                        {shipmentCardItem.locationImg ? (
                                                                            <div className="card-label localtion-img">
                                                                                {T(
                                                                                    'shippment_upload_product_placement_photo',
                                                                                )}
                                                                            </div>
                                                                        ) : null}
                                                                        <span className="preview-shipment">
                                                                            {shipmentCardItem.shipmentStatus ? (
                                                                                <Anchor
                                                                                    className="btn"
                                                                                    onClickOfSingleTap={() =>
                                                                                        this.previewPlacementImage(
                                                                                            shipmentCardItem,
                                                                                        )
                                                                                    }>
                                                                                    {T(
                                                                                        'shippment_preview',
                                                                                    )}
                                                                                </Anchor>
                                                                            ) : null}
                                                                        </span>
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        }

                                                        {shipmentCardItem.b2bShipmentFlag ===
                                                        'Y' ? (
                                                            <div className="b2b-casmart-btn-container">
                                                                <img
                                                                    src={
                                                                        base64ShippingImage
                                                                    }
                                                                    alt="Base64 Image"
                                                                />
                                                                <label>
                                                                    {T(
                                                                        'shippment_b2b_casmart_btn',
                                                                    )}
                                                                </label>
                                                                <div
                                                                    className="b2b-casmart-order-priview"
                                                                    testid="shipment-delivery-note-preview"
                                                                    onClick={() =>
                                                                        this.b2bCasmartShipmentHandle(
                                                                            {
                                                                                shipmentId:
                                                                                    shipmentCardItem.shipmentId,
                                                                                orderId:
                                                                                    shipmentDetails.orderId,
                                                                            },
                                                                        )
                                                                    }>
                                                                    {T(
                                                                        'shippment_preview',
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                        {!shipmentCardItem.changeBtn ? (
                                                            <div
                                                                className="deliver-details-switchBtn"
                                                                testid="shipment-details-package-toggle"
                                                                onClick={() => {
                                                                    this.switchBtn(
                                                                        shipmentCardIndex,
                                                                        'more',
                                                                    );
                                                                }}>
                                                                <KeyboardArrowDownIcon />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                    {shipmentCardItem.changeBtn &&
                                                    typeof shipmentCardItem.kitSkuList !==
                                                        'undefined' &&
                                                    shipmentCardItem.kitSkuList &&
                                                    shipmentCardItem.kitSkuList
                                                        .length > 0 ? (
                                                        <DeliverCard
                                                            kitSkuList={
                                                                shipmentCardItem.kitSkuList
                                                            }
                                                            changeBtn={
                                                                shipmentCardItem.changeBtn
                                                            }
                                                            index={
                                                                shipmentCardIndex
                                                            }
                                                            switchBtn={
                                                                this.switchBtn
                                                            }></DeliverCard>
                                                    ) : null}
                                                    <div
                                                        className={util.getClassName(
                                                            this.getShipmentTagStatus(
                                                                shipmentCardItem.shipmentStatus,
                                                            ),
                                                        )}></div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="first-shipment-card">
                                                        {shipmentCardItem.shipmentStatus ===
                                                        1 ? (
                                                            <div className="third-row wait-shipped-label">
                                                                {T(
                                                                    'to_send_the_goods',
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="third-row cancel-time">
                                                                <div className="card-label">
                                                                    {T(
                                                                        'shipment_cancel_time',
                                                                    )}
                                                                </div>
                                                                <span>
                                                                    {
                                                                        shipmentCardItem.cancelDate
                                                                    }
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {!shipmentCardItem.changeBtn ? (
                                                        <div
                                                            className="deliver-details-switchBtn"
                                                            testid="shipment-details-package-toggle"
                                                            onClick={() => {
                                                                this.switchBtn(
                                                                    shipmentCardIndex,
                                                                    'more',
                                                                );
                                                            }}>
                                                            <KeyboardArrowDownIcon />
                                                        </div>
                                                    ) : null}
                                                    {shipmentCardItem.changeBtn &&
                                                    typeof shipmentCardItem.kitSkuList !==
                                                        'undefined' &&
                                                    shipmentCardItem.kitSkuList &&
                                                    shipmentCardItem.kitSkuList
                                                        .length > 0 ? (
                                                        <div className="deliver-card-container">
                                                            <ul className="kit-sku-ul">
                                                                {shipmentCardItem.kitSkuList.map(
                                                                    (
                                                                        kitSkuItem,
                                                                        kitSkuIndex,
                                                                    ) => (
                                                                        <li
                                                                            className="kit-sku-li"
                                                                            key={
                                                                                kitSkuIndex
                                                                            }>
                                                                            <div className="sku-row">
                                                                                <div className="first-column">
                                                                                    <label>
                                                                                        {T(
                                                                                            'backup_sku',
                                                                                        )}
                                                                                    </label>
                                                                                    <span>
                                                                                        {
                                                                                            kitSkuItem.sku
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                                <div className="second-column">
                                                                                    <label>
                                                                                        {shipmentCardItem.shipmentStatus ===
                                                                                        1
                                                                                            ? T(
                                                                                                  'shipment_wait_quantity',
                                                                                              )
                                                                                            : T(
                                                                                                  'shipment_cancel_quantity',
                                                                                              )}
                                                                                    </label>
                                                                                    <span>
                                                                                        {
                                                                                            kitSkuItem.quantity
                                                                                        }
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            {kitSkuItem.estimatedShippingDate && (
                                                                                <div className="sku-row">
                                                                                    <div className="first-column">
                                                                                        <label>
                                                                                            {T(
                                                                                                'product_estimated_ship_date',
                                                                                            )}
                                                                                        </label>
                                                                                        <span>
                                                                                            {
                                                                                                kitSkuItem.estimatedShippingDate
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </li>
                                                                    ),
                                                                )}
                                                            </ul>
                                                        </div>
                                                    ) : null}
                                                    {shipmentCardItem.changeBtn ? (
                                                        <div
                                                            className="deliver-card-changeBtn"
                                                            testid="shipment-details-package-toggle"
                                                            onClick={() => {
                                                                this.switchBtn(
                                                                    shipmentCardIndex,
                                                                    'less',
                                                                );
                                                            }}>
                                                            <ExpandLessIcon />
                                                        </div>
                                                    ) : null}
                                                    <div
                                                        className={util.getClassName(
                                                            this.getShipmentTagStatus(
                                                                shipmentCardItem.shipmentStatus,
                                                            ),
                                                        )}></div>
                                                </div>
                                            )}
                                        </li>
                                    ),
                                )}
                            </ul>
                        ) : null}
                    </div>
                )}

                <Dialog
                    opened={previewReceiveImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewReceiveImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className={`preview-shipment-receive-image-dialog ${
                            !isHaveShipmentImage
                                ? 'shipment-receive-image-no-image'
                                : ''
                        }`}>
                        {chooseShipmentItem &&
                        chooseShipmentItem.receivedImg ? (
                            <img
                                src={
                                    util.getImageRoot() +
                                    chooseShipmentItem.receivedImg
                                }
                                alt={
                                    util.getImageRoot() +
                                    chooseShipmentItem.receivedImg
                                }
                                onError={(event) => {
                                    event.target.onerror = null;
                                    event.target.src = new URL(
                                        'Images/NoImage.png',
                                        import.meta.url,
                                    ).href;
                                }}
                            />
                        ) : (
                            T('shippment_not_upload_sign_receipt')
                        )}
                    </div>
                </Dialog>
                <Dialog
                    opened={previewPlacementImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewPlacementImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className={`preview-shipment-receive-image-dialog ${
                            !placementPreviewImg
                                ? 'shipment-receive-image-no-image'
                                : ''
                        }`}>
                        {placementPreviewImg ? (
                            <img
                                src={
                                    placementPreviewImg.startsWith('http')
                                        ? placementPreviewImg
                                        : util.getImageRoot() +
                                          placementPreviewImg
                                }
                                alt={placementPreviewImg}
                                onError={(event) => {
                                    event.target.onerror = null;
                                    event.target.src = new URL(
                                        'Images/NoImage.png',
                                        import.meta.url,
                                    ).href;
                                }}
                            />
                        ) : null}
                    </div>
                </Dialog>
                <Dialog
                    opened={previewOtherImagesDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewOtherImagesDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-shipment-other-images-dialog">
                        {chooseShipmentItem &&
                        chooseShipmentItem.otherImages &&
                        chooseShipmentItem.otherImages.length > 0 ? (
                            <>
                                <div className="preview-shipment-other-images-main">
                                    <img
                                        src={this.getPreviewImageUrl(
                                            chooseShipmentItem.otherImages[
                                                currentOtherImageIndex
                                            ].imageUrl,
                                        )}
                                        alt={this.getPreviewImageUrl(
                                            chooseShipmentItem.otherImages[
                                                currentOtherImageIndex
                                            ].imageUrl,
                                        )}
                                    />
                                </div>
                                <div className="preview-shipment-other-images-list">
                                    {chooseShipmentItem.otherImages.map(
                                        (otherImage, otherImageIndex) => (
                                            <button
                                                type="button"
                                                className={util.getClassName({
                                                    'preview-shipment-other-images-item': true,
                                                    'is-active':
                                                        currentOtherImageIndex ===
                                                        otherImageIndex,
                                                })}
                                                key={
                                                    otherImage.id ||
                                                    otherImageIndex
                                                }
                                                onClick={() =>
                                                    this.setPreviewOtherImageIndex(
                                                        otherImageIndex,
                                                    )
                                                }>
                                                <img
                                                    src={this.getPreviewImageUrl(
                                                        otherImage.imageUrl,
                                                    )}
                                                    alt=""
                                                />
                                            </button>
                                        ),
                                    )}
                                </div>
                                <BasicButton
                                    type="primary"
                                    className="preview-shipment-other-images-close-btn"
                                    onClickOfSingleTap={() =>
                                        this.dialogDidClose(
                                            'previewOtherImagesDialogOpened',
                                        )
                                    }>
                                    {T('shopping_cart_close')}
                                </BasicButton>
                            </>
                        ) : (
                            <div testid="shipment-attachment-empty-state">
                                {T('shippment_not_upload_other_photos')}
                            </div>
                        )}
                    </div>
                </Dialog>
                <Dialog
                    opened={uploadReceiveImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('uploadReceiveImageDialogOpened')
                    }
                    options={{bgClickClose: !uploadFileBtnIsLoading}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('shippment_upload_sign_receipt')}
                        </h5>
                        <p className="upload-method-subtitle text-center">
                            {T('shippment_upload_sign_receipt_by_photo')}
                        </p>
                        <BaseImageUploader
                            className="upload-method-upload"
                            onClickOfSingleTap={this.chooseImage}>
                            {chooseImage && chooseImage.url ? (
                                <img src={chooseImage.url} alt="" />
                            ) : (
                                <>
                                    <span className="upload-method-upload-icon" />
                                    <span className="upload-method-upload-text">
                                        {T(
                                            'shippment_upload_sign_receipt_by_photo_here',
                                        )}
                                    </span>
                                </>
                            )}
                            <input
                                ref="inputFile"
                                type="file"
                                accept="image/*"
                                onChange={this.selectedImage}
                            />
                        </BaseImageUploader>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                disabled={!chooseImage.file}
                                loading={uploadFileBtnIsLoading}
                                onClickOfSingleTap={this.uploadReceiveImage}>
                                <span>{T('shippment_confirm_upload')}</span>
                            </BasicButton>
                            <BasicButton
                                type="default"
                                className="upload-method-cancel"
                                onClickOfSingleTap={() => {
                                    this.setState({
                                        uploadReceiveImageDialogOpened: false,
                                        chooseImage: {file: null, url: ''},
                                    });
                                }}>
                                <span>{T('cancel')}</span>
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={addTrackNumberDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('addTrackNumberDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="track-number-dialog">
                        <h5 className="track-number-dialog-title text-center">
                            {T('shippment_input_tracking_number')}
                        </h5>
                        <div className="input-track-number">
                            <BasicInput
                                placeholder={T(
                                    'shippment_please_input_tracking_number',
                                )}
                                title=""
                                className="track-number-basic-input"
                                defaultValue={
                                    typeof currentShipments !== 'undefined' &&
                                    currentShipments.expressNumber
                                }
                                value={trackNumber}
                                inputValid={this.handleChange}
                            />
                        </div>
                        <BasicButton
                            type="primary"
                            className="add-track-number-confirm-btn"
                            onClickOfSingleTap={this.addTrackNumberHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={noOtherPhotosDialogOpened}
                    dialogDidClose={() =>
                        this.setState({noOtherPhotosDialogOpened: false})
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className="preview-shipment-receive-image-dialog shipment-receive-image-no-image"
                        testid="shipment-attachment-empty-state">
                        {T('shippment_not_upload_other_photos')}
                    </div>
                </Dialog>
                <Dialog
                    opened={uploadOtherPhotosDialogOpened}
                    dialogDidClose={() =>
                        this.setState({uploadOtherPhotosDialogOpened: false})
                    }
                    options={{bgClickClose: false}}>
                    <EditOtherPhotosDialog
                        opened={uploadOtherPhotosDialogOpened}
                        shipmentId={
                            otherPhotosShipmentItem &&
                            otherPhotosShipmentItem.shipmentId
                        }
                        receiveType={
                            otherPhotosShipmentItem &&
                            otherPhotosShipmentItem.receiveType
                        }
                        initialOtherImages={
                            (otherPhotosShipmentItem &&
                                otherPhotosShipmentItem.otherImages) ||
                            []
                        }
                        onClose={() =>
                            this.setState({
                                uploadOtherPhotosDialogOpened: false,
                            })
                        }
                        onSuccess={() => {
                            this.setState({
                                uploadOtherPhotosDialogOpened: false,
                            });
                            this.getInitData();
                        }}
                    />
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        deliverDetails: host.deliverDetails,
        localData,
    };
};

const mapDispatchToProps = {
    getDeliverDetails,
    updateTrackingNumber,
    openNotification,
    uploadReceiveImage,
    updateShipment,
    createInvoicePdf,
    enterSalesDeliverDetail,
    b2bCasmartShipment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliverDetails);
